export const OWN_TRANSPORT_INGREDIENT_SUFFIX = 'ot';
